import util from '@/util'
import constants from '@/util/constants'
import { obterImagem } from '@/util/imagem'
import mensagens from '@/util/mensagens'
import { BSpinner, BToast } from 'bootstrap-vue'
import PainelAcesso from '@/components/layout/painelAcesso/PainelAcesso.vue'

export default {
  name: 'recuperar-senha',
  components: {
    'b-spinner': BSpinner,
    'b-toast': BToast,
    PainelAcesso
  },
  computed: {
    obterLogo () {
      return obterImagem('logo-mirt-horizontal.svg')
    }
  },
  data: () => ({
    dadosFormulario: {
      emailCpf: ''
    },
    flags: {
      efetuandoRequisicao: false,
      exibirRecuperacaoSenhaSucesso: false
    },
    erroValidacaoCampos: {
      emailCpf: ''
    },
    placeholder: 'E-mail ou CPF...',
    mask: '',
    mensagemAlerta: '',
    emailRecuperacao: null
  }),
  watch: {
    'dadosFormulario.emailCpf' (value) {
      if (/^\d/.test(value)) {
        this.mask = value.length <= 14 ? '###.###.###-##' : '###.###.###-##'
      } else {
        this.mask = ''
      }
    }
  },
  mounted () {
  },

  methods: {

    eventoRecuperarSenhaTeclaEnter (evento) {
      evento.preventDefault()
      if (evento.keyCode === constants.teclado.enter) {
        this.recuperar()
      }
    },

    async recuperar () {
      if (this.flags.efetuandoRequisicao !== true) {
        this.callbackAposLoginSucesso = null
        this.mensagemAlerta = ''
        const validacaoSucesso = this.validarDadosFormulario()
        if (validacaoSucesso === true) {
          await this.efetuarRecuperacaoSenha()
        }
      }
    },

    validarDadosFormulario () {
      this.erroValidacaoCampos = {}
      const dados = this.dadosFormulario
      let validacaoSucesso = true

      if (/^\d/.test(dados.emailCpf)) {
        if (dados.emailCpf.length <= 14) {
          if (!util.validarCPF(dados.emailCpf)) {
            this.erroValidacaoCampos.emailCpf = 'Informe um CPF válido'
            validacaoSucesso = false
          }
        }
      } else {
        // Se começar com texto, validar como e-mail
        if (!util.validarEmail(dados.emailCpf)) {
          this.erroValidacaoCampos.emailCpf = 'Informe um e-mail válido'
          validacaoSucesso = false
        }
      }

      return validacaoSucesso
    },

    async efetuarRecuperacaoSenha () {
      this.flags.efetuandoRequisicao = true
      const dadosRespostaRequisicao = await this.enviarRequisicaoRecuperacaoSenha()
      const requisicaoSucesso = this.validarDadosRecuperacaoSenha(dadosRespostaRequisicao)
      if (requisicaoSucesso === true) {
        this.flags.efetuandoRequisicao = false
        this.flags.exibirRecuperacaoSenhaSucesso = true
        this.emailRecuperacao = dadosRespostaRequisicao.retorno.listaDados.email ?? ''
      } else {
        this.flags.efetuandoRequisicao = false
        this.mensagemAlerta = dadosRespostaRequisicao.retorno.mensagem
      }
    },

    async enviarRequisicaoRecuperacaoSenha () {
      let dadosRespostaRequisicao = null
      try {
        const resposta = await this.axios.post('/manager/recuperar-senha', {
          'emailCpf': this.dadosFormulario.emailCpf
        })
        dadosRespostaRequisicao = resposta.data
      } catch (e) {
        this.mensagemAlerta = mensagens.falhaComunicacaoServidor
      }
      return dadosRespostaRequisicao
    },

    validarDadosRecuperacaoSenha (dadosRespostaRequisicao) {
      if (util.valorEhNulo(dadosRespostaRequisicao)) {
        return false
      }
      const dadosRetorno = dadosRespostaRequisicao.retorno
      const recuperacaoSenha = dadosRetorno.sucesso
      if (recuperacaoSenha === false) {
        this.mensagemAlerta = dadosRetorno.mensagem
        this.erroValidacaoCampos = dadosRetorno.listaDeErros
      }

      return recuperacaoSenha
    }
  }
}
